<template>
    <section>
        <v-slider
            color="orange"
            label="Tamaño de la fuente"
            v-model="tamanioFuente"
            thumb-label="always"
        ></v-slider>
        <v-color-picker
            v-model="color"
            dot-size="25"
            swatches-max-height="200"
        ></v-color-picker>
        <v-select
            v-model="colorSeleccionado"
            :items="colores"
            label="Color"
        ></v-select>
        <v-select
            style="font-size: 25px; height: 50px !important;"
            :style="{ 'font-family': fuenteSeleccionada }"
            v-model="fuenteSeleccionada"
            :items="fuentes"
            label="Selecciona una fuente"
        >
        </v-select>

    </section>
</template>
<script>
    export default{
        name: "ConfiguracionComponent",

        data: () => ({
          colores: ['Primario', 'Secundario', 'Terciario', 'Texto'],
          tamanioFuente: 10,
          colorSeleccionado: "",
          fuenteSeleccionada: "",
          color: "",
          fuentes: [
            "Montez","Lobster","Josefin Sans","Shadows Into Light","Pacifico","Amatic SC", "Orbitron", "Rokkitt","Righteous","Dancing Script","Bangers","Chewy","Sigmar One","Architects Daughter","Abril Fatface","Covered By Your Grace","Kaushan Script","Gloria Hallelujah","Satisfy","Lobster Two","Comfortaa","Cinzel","Courgette"
          ]
        }),

        watch: {
            tamanioFuente:{
                handler(nv, ov){
                    //console.log(nv)
                    console.log(ov)

                    this.$emit("fuente", nv)
                },
                deep: true
            },

            colorSeleccionado:{
                handler(colorNuevo, colorAnterior){
                    console.log(colorAnterior)
                    let color = {
                        tipo: this.colorSeleccionado,
                        color: this.color
                    }
                    this.$emit("color", color)
                }
            },

            fuenteSeleccionada:{
                handler(nv, ov){
                    //console.log(nv)
                    console.log(ov)

                    this.$emit("familia", nv)
                },
                deep: true   
            }
        }
    }
</script>